//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppBarI18n from '@core/layouts/components/app-bar/AppBarI18n.vue'
import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'

// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// App Bar Components
// import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
// import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'

// import AppBarChat from '@core/layouts/components/app-bar/AppBarChat.vue'
// import AppBarNotification from '@core/layouts/components/app-bar/AppBarNotification.vue'
import { mdiMenu, mdiHeartOutline, mdiClose } from '@mdi/js'

import { getVuetify } from '@core/utils'

// Search Data
import { ref, watch } from '@vue/composition-api'
import { useUtils } from '@core/libs/i18n'
import themeConfig from '@themeConfig'
import appBarSearchData from '@/assets/app-bar-search-data'

import navMenuItems from '@/navigation/vertical'
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'

import AppCardUpdate from '@core/components/app-card-update/AppCardUpdate.vue'

import useAppConfig from '@core/@app-config/useAppConfig'

export default {
  components: {
    LayoutContentVerticalNav,

    AppCardUpdate,

    // AppCustomizer,
    // App Bar Components
    // AppBarSearch,
    // AppBarChat,
    // AppBarThemeSwitcher,

    AppBarI18n,
    AppBarUserMenu,

    // AppBarNotification,
  },
  setup() {
    const $vuetify = getVuetify()
    const { t } = useUtils()
    const intervalNotification = ref(null)
    /* eslint-disable object-curly-newline, operator-linebreak */
    const { menuIsVerticalNavMini, menuIsMenuHidden, appBarType, appBarIsBlurred, footerType, appContentWidth } =
      useAppConfig()

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    const notifications = ref([])

    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    const toggleAlert = (toggle, notification) => {
      const notificationsStored = localStorage.getItem('notifications')
      if (notificationsStored) {
        const arrNotifications = JSON.parse(notificationsStored)
        arrNotifications.push(notification.id)
        localStorage.setItem('notifications', JSON.stringify(arrNotifications))
      } else {
        localStorage.setItem('notifications', JSON.stringify([notification.id]))
      }
      toggle()
    }

    return {
      navMenuItems,
      handleShallShowFullSearchUpdate,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,

      notifications,
      intervalNotification,
      toggleAlert,

      menuIsVerticalNavMini,
      menuIsMenuHidden,
      appBarType,
      appBarIsBlurred,
      footerType,
      appContentWidth,
      t,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      icons: {
        mdiMenu,
        mdiHeartOutline,
        mdiClose,
      },
    }
  },
}
